import React from 'react';
import './tripPlanTree.css';

function TripPlanTreeTutorialModal({ onClose, dontShowChecked, setDontShowChecked }) {
  // Only close on close button, not on checkbox
  const handleCheckboxChange = (e) => {
    setDontShowChecked(e.target.checked);
    // Do not call onDontShowAgain here
  };
  return (
    <div className="tripplan-tutorial-modal-overlay">
      <div className="tripplan-tutorial-modal">
        <button className="tutorial-close-btn" onClick={onClose} title="Close">&times;</button>
        <h2>How to Use the Trip Plan Tree</h2>
        <ul>
          <li>
            <strong>Organize your trip by days or folders:</strong> Use the add folder/day icon at the root of the tree (<svg xmlns="http://www.w3.org/2000/svg" 
            height="20px" viewBox="0 -960 960 960" width="20px" fill="#666666" style={{verticalAlign: 'middle', marginBottom: '2px'}}><path d="M574-306h78v-74h74v-78h-74v-74h-78v74h-74v78h74v74ZM174.31-180q-37.03 0-63.67-26.64T84-270.31v-419.38q0-37.73 26.64-64.02T174.31-780h175.61l122 122h313.77q37.73 0 64.02 26.29T876-567.69v297.38q0 37.03-26.29 63.67T785.69-180H174.31Zm0-78h611.38q5.39 0 8.85-3.46t3.46-8.85v-297.38q0-5.39-3.46-8.85t-8.85-3.46H439.38l-122-122H174.31q-5.39 0-8.85 3.46t-3.46 8.85v419.38q0 5.39 3.46 8.85t8.85 3.46ZM162-258v-444 444Z"/></svg>) to add folders/days. You can also edit or remove days and folders as needed.
          </li>
          <li>
            <strong>Add events to each day or folder:</strong> For every day or folder, you can add events using the '+' icon on each day/folder row. Each event can have a type, short description, optional location, attachment, and long description.
          </li>
          <li>
            <strong>Set event location:</strong> To assign a location to an event, click the map icon 
            (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666666"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginBottom: '2px'}}>
              <path d="M21 10.5a8.38 8.38 0 0 1-1.9 5.4c-1.5 2-4.1 4.6-6.1 6.1-2-1.5-4.6-4.1-6.1-6.1A8.38 8.38 0 0 1 3 10.5a9 9 0 1 1 18 0z"/><circle cx="12" cy="10.5" r="3.5"/></svg>) next to the event description. This will fill the map search field. Use the map to find the exact place, then click <i>Add Location</i> in the info window to save the coordinates for your event.
          </li>
          <li>
            <strong>Add event from the map:</strong> You can add an event directly by clicking on the map and selecting <i>Add Location</i> in the info window to create a new event at that location.
          </li>
          <li>
            <strong>Create a route:</strong> To add a route, you need to multi-select (hold down Ctrl key) multiple events that are part of your route plan. Then a create route icon will appear at the root of the tree (<svg
             xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960"  height="20px" width="20px" fill="#666666" style={{verticalAlign: 'middle', marginBottom: '2px'}}>
                <path d="M200-160q-33 0-56.5-23.5T120-240q0-33 23.5-56.5T200-320q33 0 56.5 23.5T280-240q0 33-23.5 56.5T200-160Zm560 0q-33 0-56.5-23.5T680-240q0-33 23.5-56.5T760-320q33 0 56.5 23.5T840-240q0 33-23.5 56.5T760-160ZM240-400v-80h360l-80-80 56-56 176 176-176 176-56-56 80-80H240Z"/></svg>). You can then add the route to your trip plan by clicking the create route button.
          </li>
          <li>
            <strong>Attach and view documents:</strong> Use the attach icon (<svg xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"  height="20px" width="20px" fill="#666666" style={{verticalAlign: 'middle', marginBottom: '2px'}}><path d="M760-520q0 117-81.5 198.5T480-240q-117 0-198.5-81.5T200-520v-240q0-75 52.5-127.5T380-940q75 0 127.5 52.5T560-760v200q0 42-29 71t-71 29q-42 0-71-29t-29-71v-200h80v200q0 8 6 14t14 6q8 0 14-6t6-14v-200q0-42-29-71t-71-29q-42 0-71 29t-29 71v240q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520v-240h80v240Z"/></svg>) to add a document to any event. To view an attached document, simply click the attach icon next to your event.
          </li>
        </ul>
        <div className="tutorial-modal-actions">
          <label className="dont-show-label">
            <input
              type="checkbox"
              checked={dontShowChecked}
              onChange={handleCheckboxChange}
            />
            <span>Don’t show this tutorial again</span>
          </label>
        </div>
        <div className="tripplan-tutorial-modal-arrow"></div>
      </div>
    </div>
  );
}

export default TripPlanTreeTutorialModal;
